import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const getTermStatusOptions = (customerTermStatusList) => {
  let statusList = ['PENDING', 'PENDING_INVOICE', 'PAID'];
  if (
    ['Prieto González', 'Coronel Cantero'].includes(
      JSON.parse(localStorage.user).surnames
    )
  ) {
    statusList.push('CANCELLED');
  }

  return customerTermStatusList
    .filter((x) => statusList.includes(x.code))
    .map((x) => {
      return { id: x.id, name: x.code };
    });
};

const isEnabledTermStatus = (customerTermStatusList, customerTermStatusId) => {
  let statusList = ['PENDING', 'PENDING_INVOICE', 'PENDING_PAYMENT', 'PAID'];
  if (
    ['Prieto González', 'Coronel Cantero'].includes(
      JSON.parse(localStorage.user).surnames
    )
  ) {
    statusList.push('CANCELLED');
  }

  return statusList.includes(
    customerTermStatusList.filter((x) => x.id === customerTermStatusId)[0].code
  );
};

const CustomerTerm = ({ fields, customerTermStatusList }) => [
  {
    name: 'customerTermStatusId',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.SELECT,
    value: fields && fields.customerTermStatusId,
    options: getTermStatusOptions(
      customerTermStatusList,
      fields.customerTermStatusId
    ),
    enabled: isEnabledTermStatus(
      customerTermStatusList,
      fields.customerTermStatusId
    )
  },
  {
    name: 'number',
    validation: yup.number(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.number ? fields.number : '0',
    readonly: true
  },
  {
    name: 'date',
    validation: yup.date(),
    type: FormFieldType.DATE,
    value: fields && fields.date ? fields.date : new Date(),
    readonly: true
  },
  {
    name: 'totalPrice',
    validation: yup.number(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.totalPrice ? fields.totalPrice : '0',
    readonly: true
  },
  {
    name: 'amount',
    validation: yup.number(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.amount ? fields.amount : '0',
    readonly: true
  },
  {
    name: 'rest',
    validation: yup.number(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.rest ? fields.rest : '0',
    readonly: true
  },
  {
    name: 'detail',
    validation: yup.string(),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.detail ? fields.detail : '',
    readonly: true
  }
];

export default CustomerTerm;
